import React from "react";
import "../css/TextFile.css";

const TemporaryAbout = () => {
  return (
    <div className="textfile-container">
      <p>hello! welcome to menaOS version 2.0</p>
      <p>where all my fun lil coding experiments live</p>
      <p>this site is a work in progress. hope you enjoy your stay!</p>
    </div>
  );
};

export default TemporaryAbout;
